module.exports = __webpack_public_path__ + "static/media/4_Kate_N@2x.f9a93434.jpg";